import React, { useEffect, useState } from 'react';
import './styles.scss';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AppWrapper from '../../components/app-wrapper';
import { Column, Row } from '../../components/layout';
import Header1 from '../../components/headers/header1';
import * as fonts from '../../util/fonts';
import { get } from '../../api/api';
import {
  getFaqs,
} from '../../api/endpoints';
import { labelsParagraphs } from '../../util/utility';
import { addToWizard, setWizard } from '../../store/actions';
import AppParagraph from '../../components/app-paragraph';
import ErrorMessage from './../../components/forms/ErrorMessage';

interface FaqsProps {
  stringsDefault: any;
}

function Faqs({ stringsDefault }: FaqsProps) {
  const [pageContent, setPageContent] = useState('');
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    getPage();
  }, []);

  const getPage = async () => {
    try {
      const response: any = await get(getFaqs());
      setPageContent(response.content);
      labelsParagraphs(pageContent);
    } catch (e: any) {
      setShowError(true);
    }
  };

  return (
    <>
      <Row className="reimbursement-history-titlerow reimbursement-history-row">
        <Column>
          <Header1
            className="reimbursement-history-heading1 talk-with-us-heading"
            style={{ ...fonts.XL, ...fonts.Bold }}>
            {stringsDefault.faqs_title}
          </Header1>
          <p className="separator"></p>
          <Row className="reimbursement-history-titlecolumn">
            <AppParagraph label={pageContent} />
          </Row>
          <ErrorMessage error={stringsDefault.faqs_error} visible={showError} />
        </Column>
      </Row>
    </>
  );
}

const mapStateToProps = ({ stringsDefault }: any) => ({
  stringsDefault: stringsDefault.value.pt.frequentQuestions,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(Faqs));
